'use client';
import React from 'react';
import { Box, Link, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import CommonDynamicSlider from '../CommonDynamicSlider';
import DynamicButton from '@components/DynamicButton';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
export default function WestminsterTowerContemporary(
  props: MarketingPageComponentProps
) {
  const section = props?.locale?.section || {};
  const towerShowcaseSlider =
    props?.locale?.section?.westminsterTowerShowcaseSlider ?? [];
  const propertyButton = section?.['westminsterTowerHomePropertyButton'] || {};
  return (
    <Stack component="section" className={cn.westminsterTowerContemporary}>
      <Box className={cn.westminsterContemporaryInner}>
        <Box className={cn.westminsterContemporarySlider}>
          <CommonDynamicSlider
            data={towerShowcaseSlider}
            className={cn.makeWorldStoryElement}
          />
        </Box>
        <Box
          className={cn.westminsterContemporaryBody}
          sx={{
            backgroundImage: `url(${props.images.westminster_tower_light_background?.src})`,
          }}
        >
          <CommonContainer
            paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
            maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
            flexGrow={1}
          >
            <Box className={cn.westminsterContemporaryContent}>
              <Box className={cn.westminsterContemporaryContent__data}>
                <Mobile>
                  <ParallaxText
                    variant="h2"
                    animationType="slideInBottom"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      props.locale.section.westminsterTowerShowcaseHeadingMobile
                    )}
                  </ParallaxText>
                </Mobile>
                <Desktop>
                  <ParallaxText
                    variant="h2"
                    animationType="slideInBottom"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      props.locale.section
                        .westminsterTowerShowcaseHeadingDesktop
                    )}
                  </ParallaxText>
                </Desktop>
                <ParallaxText
                  variant="p"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    props.locale.section.westminsterTowerShowcaseContent
                  )}
                </ParallaxText>
              </Box>
              <Box className={cn.westminsterContemporaryContent__button}>
                <DynamicButton
                  showLink
                  className={cn.westminsterContemporaryButton}
                  url={propertyButton?.link || ''}
                  linkLabel={propertyButton?.label || ''}
                />
              </Box>
            </Box>
          </CommonContainer>
        </Box>
      </Box>
    </Stack>
  );
}
